import { Fixed } from '@flippingbook/web.react-kit/dist/Fixed';
import { useState } from 'react';
import type { ReactNode } from 'react';

import { Header } from '@/site/components/Header';
import { DefaultHelpMenu } from '@/site/components/HelpMenu';

import { b, e } from './style.css';

export function HeadedPage(props: HeadedPage.Props) {
    const { children, headerProps, isDesktop } = props;

    const [stubHeight, setStubHeight] = useState(0);

    return (
        <div className={b.name}>
            <div className={e.header}>
                <Fixed
                    left={0}
                    right={0}
                    top={0}
                    zIndex={9995}
                    isDesktop={isDesktop}
                    onHeightChange={setStubHeight}
                >
                    <Header
                        helpMenu={<DefaultHelpMenu />}
                        {...headerProps}
                    />
                </Fixed>
            </div>
            <div
                className={e.body}
                style={{ height: `calc(100% - ${stubHeight}px)` }}
            >
                {children}
            </div>
        </div>
    );
}

export namespace HeadedPage {
    export interface Props {
        children: ReactNode;
        headerProps: Partial<Header.Props>;
        isDesktop?: boolean;
        helpMenu?: React.ReactNode;
    }
}
